<div id="{{position}}" class="position-relative"
    [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
    [ngClass]="activatePadding?'header-padding-top':''">
    <div *ngIf="!loading">
        <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null" class="app-header-background"
            [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
            <div class="app-header-section pt-20 gallery-max-width">
                <div class="app-header-headline form-headline pt-20" style="text-align: center">
                    <h1 [attr.data-aos]="textAnimation ? textAnimation : null" class="mat-h1"
                        [ngStyle]="{'color': textColor}">
                        {{ title }}</h1>
                    <p [attr.data-aos]="textAnimation ? textAnimation : null" *ngIf="subTitle" class="sub-title center"
                        [ngStyle]="{'color': textColor}">{{subTitle}}</p>
                    <br><br>
                    <app-gallery [attr.data-aos]="imagesAnimation ? imagesAnimation : null"
                        (viewerChange)="onViewerVisibilityChanged($event)" [flexBorderSize]="flexBorderSize"
                        [flexImageSize]="flexImageSize" [maxRowsPerPage]="15" [galleryTitle]="title"
                        [siteName]="siteName" [metadataUri]="metadataUri">
                    </app-gallery>
                    <br /><br />
                </div>
            </div>
        </header>
    </div>
</div>